import router from "@/router";
import {auth_api, blocking_auth_api} from "@/axios";
import {useToast} from "vue-toastification";

const toast = useToast();

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

const local_storage_token_key = 'auth_token';

const state = () => ({
    token: null,
    data: null,
})

const getters = {}

const actions = {
    async init(context) {
        let token = localStorage.getItem(local_storage_token_key);
        if (token && parseJwt(token).exp < Math.floor(Date.now() / 1000)) {
            token = null;
            localStorage.removeItem(local_storage_token_key);
        }

        if (token)
            await context.dispatch('refresh_token_and_timeouts', token);

        if (context.state.token) {
            auth_api.get("/api/user/login_refresh")
                .then(() => {

                })
                .catch(err => {
                    switch (err.response.data.result) {
                        case 'unauthorized':
                            toast.error("Password not Recognized");
                            break;
                    }
                });
        }

        return Promise.resolve();
    },
    async login(context, credentials) {
        return blocking_auth_api.post("/api/user/login", credentials)
            .then(() => {
                if('name' in context.state.data && context.state.data.name)
                    router.replace({name: 'media_viewer'})
                else
                    router.push({name: 'ask_name'})
            })
    },
    refresh_token_and_timeouts(context, token) {
        if (!token) {
            router.replace({name: 'login'})
            return
        }
        context.commit('set_token', token);
    },
    logout(context) {
        context.commit('set_token', null);
        localStorage.removeItem(local_storage_token_key);

        const route = {name: 'login'}
        auth_api.post("/api/user/logout")
            .then(() => router.push(route))
            .catch(() => router.push(route));
    }
}

const mutations = {
    set_token(state, token) {
        if (token) {
            localStorage.setItem(local_storage_token_key, token);
            state.token = token;
            state.data = token && parseJwt(token);
        } else {
            localStorage.removeItem(local_storage_token_key);
            state.token = null;
            state.data = null;
        }
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}